
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M7.104 22h7.792a.688.688 0 000-1.375H7.104a.688.688 0 000 1.375z"}}),_c('path',{attrs:{"d":"M11 22c.38 0 .688-.308.688-.688v-3.666a.688.688 0 00-1.376 0v3.666c0 .38.309.688.688.688zM11 8.25a2.753 2.753 0 002.75-2.75A2.753 2.753 0 0011 2.75 2.753 2.753 0 008.25 5.5 2.753 2.753 0 0011 8.25zm0-4.125c.758 0 1.375.617 1.375 1.375S11.758 6.875 11 6.875A1.377 1.377 0 019.625 5.5c0-.758.617-1.375 1.375-1.375z"}}),_c('path',{attrs:{"d":"M11 11c3.262 0 6.313-1.929 8.16-5.159a.686.686 0 000-.682C17.312 1.929 14.261 0 11 0 7.738 0 4.687 1.929 2.84 5.159a.686.686 0 000 .682C4.688 9.071 7.739 11 11 11zm6.762-5.5C16.151 8.09 13.65 9.625 11 9.625c-2.65 0-5.15-1.534-6.762-4.125C5.849 2.91 8.35 1.375 11 1.375c2.65 0 5.15 1.534 6.762 4.125z"}}),_c('path',{attrs:{"d":"M1.604 18.333h18.792c.884 0 1.604-.72 1.604-1.604V4.354a.688.688 0 00-1.375 0V16.73c0 .125-.105.23-.23.23H1.606a.232.232 0 01-.23-.23V4.354a.688.688 0 00-1.375 0V16.73c0 .885.72 1.604 1.604 1.604z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"matrix(-1 0 0 1 22 0)","d":"M0 0h22v22H0z"}})])])])
          )
        }
      }
    